import NoVideoIcon from "../../../assets/img/movement/noVideoIcon.svg";
import VideoIcon from "../../../assets/img/movement/videoIcon.svg";
import NoAudioIcon from "../../../assets/img/movement/noAudioIcon.svg";
import AudioIcon from "../../../assets/img/movement/audioIcon.svg";
import SwitchCamera from "../../../assets/img/movement/switchCamera.svg";
import React from "react";
import Tooltip from "../../tooltip/Tooltip";

const TelemedicineVideoToolbar = ({ onClicks, controlStates }) => {
    const { isVideoHidden, isAudioMuted } = controlStates;
    const { onClickMuteUnmuteVideo, onClickMuteUnmuteAudio, onClickCameraSwitch } = onClicks;

    return (
        <>
            <div className="telemedicine-video-guideline-container__video-toolbar">
                <div className="padding-bottom-12">
                    <div className="">
                        <div className="cursor-pointer"
                             id="video-camera-unmute"
                             onClick={onClickMuteUnmuteVideo}
                        >
                            {isVideoHidden && (
                                <img src={NoVideoIcon} alt="VideoUnmute"/>
                            )}
                            {!isVideoHidden && (
                                <img src={VideoIcon} alt="VideoUnmute"/>
                            )}
                        </div>
                    </div>
                    {/*{isVideoHidden && (*/}
                    {/*    <Tooltip*/}
                    {/*        placement="bottom"*/}
                    {/*        target="video-camera-unmute">*/}
                    {/*        HIDE VIDEO*/}
                    {/*    </Tooltip>*/}
                    {/*)}*/}
                    {/*{!isVideoHidden && (*/}
                    {/*    <Tooltip*/}
                    {/*        placement="bottom"*/}
                    {/*        target="video-camera-unmute">*/}
                    {/*        SHOW VIDEO*/}
                    {/*    </Tooltip>*/}
                    {/*)}*/}
                </div>
                <div className="padding-bottom-12">
                    <div className="">
                        <div className="cursor-pointer"
                             id="audio-unmute"
                             onClick={onClickMuteUnmuteAudio}
                        >
                            {isAudioMuted && (
                                <img src={NoAudioIcon} alt="AudioMute"/>
                            )}
                            {!isAudioMuted && (
                                <img src={AudioIcon} alt="AudioMute"/>
                            )}
                        </div>
                    </div>
                    {/*{isAudioMuted && (*/}
                    {/*    <Tooltip*/}
                    {/*        placement="bottom"*/}
                    {/*        target="audio-unmute">*/}
                    {/*        MUTE AUDIO*/}
                    {/*    </Tooltip>*/}
                    {/*)}*/}
                    {/*{!isAudioMuted && (*/}
                    {/*    <Tooltip*/}
                    {/*        placement="bottom"*/}
                    {/*        target="audio-unmute">*/}
                    {/*        UNMUTE AUDIO*/}
                    {/*    </Tooltip>*/}
                    {/*)}*/}
                </div>

                <div className="padding-bottom-12">
                    <div className="">
                        <div className="cursor-pointer"
                             id="camera-switch"
                             onClick={onClickCameraSwitch}
                        >
                            {(
                                <img src={SwitchCamera} alt="AudioMute"/>
                            )}
                        </div>
                    </div>
                    {isAudioMuted && (
                        <Tooltip
                            placement="bottom"
                            target="camera-switch">
                            SWITCH CAMERA
                        </Tooltip>
                    )}
                </div>
            </div>
        </>
    )
}

export default TelemedicineVideoToolbar;
